const translations = {
    userAgree: {
        type: {
            regulations: {
                label: 'Regulamin i polityka prywatności',
                content: 'Oświadczam, że akceptuję postanowienia <a href="/" target="_blank">Regulaminu</a> i <a href="/" target="_blank">Polityki prywatności</a>.',
            },
            marketing: {
                label: 'Oferty handlowe mail i tel',
                content: 'Oświadczam, że wyrażam dobrowolną zgodę na przetwarzanie moich danych osobowych obejmujących imię, nazwisko, adres email i numer telefonu w celu, o którym mowa w Rozdziale VI. „Cele i podstawy przetwarzania danych osobowych” <a href="/" target="_blank">Polityki Prywatności</a>, tj. w celach marketingu usług własnych, w tym marketingu bezpośredniego, oferowanych przez POCHP AI sp. z o.o. (Administrator) przez okres trwania umowy o świadczenie usług drogą elektroniczną, której to stajesz się stroną, ale nie dłużej niż do dnia cofnięcia tej zgody. Zaznaczenie niniejszej zgody jest dobrowolne, a brak wyrażenia zgody nie skutkuje dla Ciebie negatywnymi konsekwencjami, w szczególności nie stanowi przeszkody do zawarcia umowy o świadczenie usług drogą elektroniczną z Administratorem.',
            },
        },
    },
};

export default translations;